"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderLightboxNav = exports.renderLightboxMain = exports.renderLightbox = exports.renderGallery = exports.closeLightBox = void 0;
var _react = _interopRequireDefault(require("react"));
var _CloseIcon = require("./CloseIcon");
var _renderImageOrLottieAnimation = require("../../utils/renderImageOrLottieAnimation");
var _generateFocusedImageAlt = _interopRequireDefault(require("../../utils/generateFocusedImageAlt"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _Image = _interopRequireDefault(require("../Image/Image"));
var _Video = _interopRequireDefault(require("../Video/Video"));
var _Slider = _interopRequireDefault(require("./Slider"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const scrollFocusedImageSizes = {
  desktop: {
    width: 1120,
    height: 630,
    ratio: {
      width: 16,
      height: 9
    }
  },
  tablet: {
    width: 840,
    height: 480,
    ratio: {
      width: 7,
      height: 4
    }
  },
  mobile: {
    width: 550,
    height: 310,
    ratio: {
      width: 16,
      height: 9
    }
  }
};
const splitScrollFocusedImageSizes = {
  desktop: {
    width: 560,
    height: 560,
    ratio: {
      width: 1,
      height: 1
    }
  },
  tablet: {
    width: 840,
    height: 840,
    ratio: {
      width: 1,
      height: 1
    }
  },
  mobile: {
    width: 550,
    height: 550,
    ratio: {
      width: 1,
      height: 1
    }
  }
};
const renderMainScrollImage = (activeImage, galleryType) => {
  if (activeImage?.type === "YouTube" || activeImage?.type === "Vimeo") {
    const video = {
      url: activeImage?.videoUrl,
      allowFullScreen: true
    };
    const thumbnail = {
      src: activeImage?.url,
      alt: activeImage?.alt
    };
    const videoContent = {
      video,
      thumbnail,
      variant: "variant_7"
    };
    return /*#__PURE__*/_react.default.createElement(_Video.default, {
      content: videoContent
    });
  } else if (activeImage?.type === "Vidyard") {
    const video = {
      url: null,
      uuid: activeImage?.uuid,
      allowFullScreen: true,
      vidyard: true
    };
    const thumbnail = {
      src: activeImage?.url,
      alt: activeImage?.alt
    };
    const videoContent = {
      video,
      thumbnail,
      variant: "variant_7"
    };
    return /*#__PURE__*/_react.default.createElement(_Video.default, {
      content: videoContent
    });
  } else if (activeImage?.type === "lottieAnimation") {
    const activeImageStyles = {
      ...activeImage?.style,
      height: "720px"
    };
    const lottieRatio = galleryType === "Split" ? {
      height: 1,
      width: 1
    } : {
      height: 9,
      width: 16
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-image-gallery__main-image ter-image-gallery__main-image--lottie"
    }, (0, _renderImageOrLottieAnimation.renderImageOrLottieAnimation)(activeImage, null, null, null, "ter-image-gallery__lottie", activeImageStyles, true, lottieRatio));
  } else if (activeImage?.x && activeImage?.y) {
    const imageSizeArray = galleryType === "Split" || galleryType === "product" ? {
      ...splitScrollFocusedImageSizes
    } : {
      ...scrollFocusedImageSizes
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-image-gallery__main-image ter-image-gallery__main-image--focused"
    }, (0, _renderImageOrLottieAnimation.renderImageOrLottieAnimation)(activeImage, null, imageSizeArray, (0, _generateFocusedImageAlt.default)(activeImage), "ter-image-gallery__focused", null));
  } else {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-image-gallery__main-image ter-image-gallery__main-image--regular"
    }, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: activeImage?.url,
      alt: activeImage?.alt || activeImage?.altText || activeImage?.title
    }));
  }
};
const openLightBox = updateShowLightBox => {
  updateShowLightBox(true);
  document.querySelector("body").style.overflow = "hidden";
};
const closeLightBox = updateShowLightBox => {
  updateShowLightBox(false);
  document.querySelector("body").style.overflow = "auto";
};
exports.closeLightBox = closeLightBox;
const renderMosaicGallery = () => {
  return /*#__PURE__*/_react.default.createElement("p", null, "TODO");
};
const renderMainImageBorders = () => {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-image-gallery__image-border ter-image-gallery__image-border-top-left"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-image-gallery__image-border ter-image-gallery__image-border-top-right"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-image-gallery__image-border ter-image-gallery__image-border-left"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-image-gallery__image-border ter-image-gallery__image-border-right"
  }));
};
const renderGalleryPanel = (content, noButton, updateCurrentImage, currentThumb, updateCurrentThumb, thumbnailWrapper, updateShowLightbox, currentImage, type, sliderQty) => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-image-gallery__holder ${!content?.thumbnailAlignment ? "ter-image-gallery__holder--reverse" : ""}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-image-gallery__nav"
  }, renderCarousel(content, updateCurrentImage, currentThumb, updateCurrentThumb, thumbnailWrapper, noButton, type, sliderQty), !noButton && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: () => openLightBox(updateShowLightbox),
    text: `View All (${content?.images?.length})`,
    className: "ter-button--primary--2"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-image-gallery__images"
  }, renderMainScrollImage(currentImage, type), renderMainImageBorders()));
};
const renderCarousel = (content, updateCurrentImage, currentThumb, updateCurrentThumb, thumbnailWrapper, noButton, type, sliderQty) => {
  if (content?.images?.length <= Number(sliderQty)) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `ter-image-gallery__thumbnails ${noButton ? `ter-image-gallery__thumbnails--no-button` : ""}`,
      ref: thumbnailWrapper
    }, renderThumbnails(content, updateCurrentImage, currentThumb, updateCurrentThumb, thumbnailWrapper));
  } else {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-image-gallery__thumbnails",
      ref: thumbnailWrapper
    }, /*#__PURE__*/_react.default.createElement(_Slider.default, {
      className: type ? `ter-slider--${type}` : null
    }, renderThumbnails(content, updateCurrentImage, currentThumb, updateCurrentThumb, thumbnailWrapper)));
  }
};
const renderGallery = (content, type, thumbnailWrapper, currentImage, updateCurrentImage, currentThumb, updateCurrentThumb, updateShowLightbox, noButton, sliderQty) => {
  if (type === "ContentfulImageGalleryMosaic") {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `ter-image-gallery__holder`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-image-gallery__mosaic"
    }, renderMosaicGallery()));
  } else if (type === "Split") {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `ter-image-gallery--split ${content?.reverseAlignment === true ? "ter-image-gallery--split-reverse" : ""}`
    }, renderGalleryPanel(content, noButton, updateCurrentImage, currentThumb, updateCurrentThumb, thumbnailWrapper, updateShowLightbox, currentImage, type, sliderQty), content?.sideContent && /*#__PURE__*/_react.default.createElement("div", {
      className: `ter-image-gallery__content`
    }, content?.sideContent));
  } else {
    return renderGalleryPanel(content, noButton, updateCurrentImage, currentThumb, updateCurrentThumb, thumbnailWrapper, updateShowLightbox, currentImage, type, sliderQty);
  }
};
exports.renderGallery = renderGallery;
const renderThumbnails = (content, updateCurrentImage, currentThumb, updateCurrentThumb, thumbnailWrapper) => {
  return content?.images?.map((image, index) => {
    if (image?.src && !image?.url) {
      image.url = image.src;
    }
    const isVideo = image?.type === "YouTube" || image?.type === "Vimeo" || image?.type === "Vidyard";
    return /*#__PURE__*/_react.default.createElement("div", {
      key: `thumb-` + index,
      className: `ter-image-gallery__thumbnail-wrapper ${index === currentThumb ? "ter-image-gallery__thumbnail-wrapper--active" : ""}`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `ter-image-gallery__thumbnail ${isVideo ? 'ter-image-gallery__thumbnail--video' : ''}`,
      onClick: () => updateGalleryImage(content, updateCurrentImage, thumbnailWrapper, updateCurrentThumb, index),
      "data-thumb-index": index + 1
    }, renderThumbnailImage(image)));
  });
};
const renderThumbnailImage = image => {
  if (image?.type === "lottieAnimation") {
    const imageStyles = {
      ...image?.style,
      height: "90px",
      width: "90px"
    };
    const lottieRatioThumb = {
      height: 1,
      width: 1
    };
    return (0, _renderImageOrLottieAnimation.renderImageOrLottieAnimation)(image, null, null, null, "ter-image-gallery__lottie--thumb", imageStyles, true, lottieRatioThumb);
  } else {
    return /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: image?.url && image?.url + "?w=180",
      alt: image?.alt && image?.alt,
      className: `ter-image-gallery__image ${image?.className ? image?.className : ""}`
      //contentfulId={image?.contentfulId} annotation disabled due to unclickable area
    });
  }
};
const updateGalleryImage = (content, updateCurrentImage, thumbnailWrapper, updateCurrentThumb, activeIndex) => {
  updateCurrentImage(content?.images[activeIndex]);
  if (thumbnailWrapper && thumbnailWrapper.current) {
    updateCurrentThumb(activeIndex);
  }
};
const renderLightboxNav = content => {
  return content?.images?.map((image, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "carousel-cell ter-image-gallery__lightbox-nav-item"
    }, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: image?.url && image?.url + "?w=160",
      alt: image?.alt && image?.alt,
      className: image?.className && image?.className
    }));
  });
};
exports.renderLightboxNav = renderLightboxNav;
const renderLightboxMain = content => {
  return content?.images?.map((image, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "carousel-cell ter-image-gallery__lightbox-main-item"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "carousel-cell__inner"
    }, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: image?.url && image?.url + "?w=1800",
      alt: image?.alt && image?.alt,
      className: image?.className && image?.className
    })));
  });
};
exports.renderLightboxMain = renderLightboxMain;
const renderLightbox = (showLightbox, lightboxNav, content, lightboxNavHorz, updateShowLightbox, lightboxMain) => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-image-gallery__lightbox ${showLightbox ? "ter-image-gallery__lightbox--visible" : ""}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: lightboxNav,
    className: `ter-image-gallery__lightbox-nav ter-image-gallery__lightbox-nav--vert`
  }, renderLightboxNav(content)), /*#__PURE__*/_react.default.createElement("div", {
    ref: lightboxNavHorz,
    className: `ter-image-gallery__lightbox-nav ter-image-gallery__lightbox-nav--horz`
  }, renderLightboxNav(content)), /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-image-gallery__lightbox-wrapper`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-image-gallery__close`,
    onClick: () => closeLightBox(updateShowLightbox)
  }, /*#__PURE__*/_react.default.createElement(_CloseIcon.CloseIcon, {
    iconColor: "#ffffff"
  })), /*#__PURE__*/_react.default.createElement("div", {
    ref: lightboxMain,
    className: `ter-image-gallery__lightbox-main`
  }, renderLightboxMain(content))));
};
exports.renderLightbox = renderLightbox;